import { Static, Object, String, Boolean } from '@sinclair/typebox';

import { TravelPassApiAnyError } from './error';

export const TravelPassUserDetailsError = TravelPassApiAnyError();
export type TravelPassUserDetailsError = Static<typeof TravelPassUserDetailsError>;

export const TravelPassUserDetailsResponse = Object({
  accountNumber: String(),
  firstName: String(),
  lastName: String(),
  isTravelAdmin: Boolean(),
});
export type TravelPassUserDetailsResponse = Static<typeof TravelPassUserDetailsResponse>;
